import ActionType from 'actions/ActionType'

export default (state = 'newestFirst', action) => {
  switch (action.type) {
    case ActionType.Tasks.CHANGE_SORT:
      return action.payload
    default:
      return state
  }
}
